export default "__VITE_ASSET__BV9xA8oW__"